var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "add-info-form"
  }, [_vm._l(_vm.showdata, function (every, i) {
    return _c("div", {
      key: i
    }, [_c("top-title", [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t("投保信息") + (i != 0 ? i + 1 : "")))]), i != 0 ? _c("div", {
      staticStyle: {
        "font-size": "20px"
      },
      attrs: {
        slot: "des"
      },
      slot: "des"
    }, [_c("a-icon", {
      staticStyle: {
        transform: "rotate(-45deg)"
      },
      attrs: {
        type: "plus-circle"
      },
      on: {
        click: function ($event) {
          return _vm.delInfo(i);
        }
      }
    })], 1) : _vm._e()]), _vm._l(every, function (item, index) {
      return _c("div", {
        key: index
      }, [item.item ? _c("h5", {
        staticStyle: {
          "font-weight": "700",
          "font-size": "14px",
          padding: "0 20px"
        }
      }, [_vm._v(" " + _vm._s(_vm.$t(item.name.includes("信息") ? item.name : item.name + "信息")) + " ")]) : _vm._e(), _c("a-form-model", {
        ref: "formRef" + i + index,
        refInFor: true,
        staticClass: "info-form",
        attrs: {
          model: {},
          rules: _vm.rules,
          "label-col": {
            span: _vm.isAdd ? 7 : 8
          },
          "wrapper-col": {
            span: 16
          }
        }
      }, _vm._l(item.item, function (item1, index1) {
        return _c("a-form-model-item", {
          key: index1,
          class: item1.display == "radio" ? "nowrap" : "box",
          attrs: {
            prop: item1.code + i
          }
        }, [_c("template", {
          slot: "label"
        }, [_vm._v(" " + _vm._s(_vm.$t(item1.name)) + " ")]), item1.display == "radio" ? _c("a-radio-group", {
          attrs: {
            disabled: i != 0 || !_vm.isAdd ? true : false
          },
          on: {
            change: e => _vm.updateForm(e, "radio", i, index, index1)
          },
          model: {
            value: item1.inputKey,
            callback: function ($$v) {
              _vm.$set(item1, "inputKey", $$v);
            },
            expression: "item1.inputKey"
          }
        }, _vm._l(item1.value, function (radio, index2) {
          return _c("a-radio", {
            key: index2,
            attrs: {
              value: radio.key
            }
          }, [_vm._v(_vm._s(_vm.$t(radio.value)))]);
        }), 1) : _vm._e(), item1.display == "text" ? _c("a-input", {
          attrs: {
            placeholder: _vm.$t("请填写") + _vm.$t(item1.name),
            disabled: item1.disabled || item.item.findIndex(i => i.code == "applicantType" && i.inputKey == "COMPANY") > -1 && i > 0
          },
          on: {
            input: e => _vm.updateForm(e, "text", i, index, index1)
          },
          model: {
            value: item1.inputKey,
            callback: function ($$v) {
              _vm.$set(item1, "inputKey", $$v);
            },
            expression: "item1.inputKey"
          }
        }) : _vm._e(), item1.display == "dropDownBox" ? _c("a-select", {
          attrs: {
            placeholder: _vm.$t("请选择") + _vm.$t(item1.name),
            disabled: item1.disabled || item.item.findIndex(i => i.code == "applicantType" && i.inputKey == "COMPANY") > -1 && i > 0,
            getPopupContainer: triggerNode => triggerNode.parentNode
          },
          on: {
            change: e => _vm.updateForm(e, "dropDownBox", i, index, index1)
          },
          model: {
            value: item1.inputKey,
            callback: function ($$v) {
              _vm.$set(item1, "inputKey", $$v);
            },
            expression: "item1.inputKey"
          }
        }, _vm._l(item1.value, function (item2, index2) {
          return _c("a-select-option", {
            key: index2,
            attrs: {
              value: item2.key
            }
          }, [_vm._v(" " + _vm._s(item2.value) + " ")]);
        }), 1) : _vm._e(), item1.display == "time" ? _c("a-date-picker", {
          staticClass: "input-warp",
          staticStyle: {
            width: "100%"
          },
          attrs: {
            allowClear: "",
            format: _vm.getFormatDate(),
            valueFormat: "YYYY-MM-DD",
            placeholder: _vm.$t("请选择") + _vm.$t(item1.name),
            disabled: item1.disabled || item.item.findIndex(i => i.code == "applicantType" && i.inputKey == "COMPANY") > -1 && i > 0,
            getCalendarContainer: triggerNode => triggerNode.parentNode
          },
          on: {
            change: e => _vm.updateForm(e, "time", i, index, index1)
          },
          model: {
            value: item1.inputKey,
            callback: function ($$v) {
              _vm.$set(item1, "inputKey", $$v);
            },
            expression: "item1.inputKey"
          }
        }) : _vm._e(), item1.display == "dropDownBox(region)" ? _c("a-cascader", {
          attrs: {
            allowClear: "",
            options: _vm.areaList,
            "field-names": {
              label: "name",
              value: "code",
              children: "children",
              disabled: "disabled"
            },
            placeholder: _vm.$t("请选择") + _vm.$t(item1.name),
            disabled: item1.disabled || item.item.findIndex(i => i.code == "applicantType" && i.inputKey == "COMPANY") > -1 && i > 0,
            getPopupContainer: triggerNode => triggerNode.parentNode
          },
          on: {
            change: e => _vm.updateForm(e, "dropDownBox(region)", i, index, index1)
          },
          model: {
            value: item1.inputKey,
            callback: function ($$v) {
              _vm.$set(item1, "inputKey", $$v);
            },
            expression: "item1.inputKey"
          }
        }) : _vm._e()], 2);
      }), 1)], 1);
    })], 2);
  }), _vm.isAdd && _vm.showdata.length < 50 ? _c("a-button", {
    staticClass: "marginT20",
    on: {
      click: _vm.addInfo
    }
  }, [_vm._v(_vm._s(_vm.$t("新增") + _vm.$t("投保信息")))]) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };